// dATOS eNTRE pAGINAS
const state = () => ({
  cuotasACobrar: [],
})

// getters
const getters = {
  getCuotas (state) {
    return state.cuotasACobrar
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  setCuotas (state, payload) {
    state.cuotasACobrar = payload.payload
  },
  deleteCuotas (state) {
    state.cuotasACobrar = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
